import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useI18n } from '@/i18n/I18nProvider';
import { PageHeading } from '@/components/PageHeading';

/** `*`: unknown route, or a customer id outside the session. */
export function NotFoundScreen() {
  const { t } = useI18n();
  return (
    <div className="flex flex-col items-start gap-400 pt-400" data-screen="NotFoundScreen">
      <PageHeading>{t('error.notFound')}</PageHeading>
      <Link to="/" className="focus-ring text-callout text-typography-primary inline-flex min-h-[44px] items-center gap-100 underline">
        <ArrowLeft size={16} aria-hidden="true" />
        {t('common.back')}
      </Link>
    </div>
  );
}
